var Layout    = require("app/ui/Layout"),
    get       = require("object-path").get,
    kind      = require("enyo/kind"),
    themeVars = require("app/theme/variables");

module.exports = kind(/** @lends  app.PlaylistPage.PrefixLayout.prototype */ {

    /**
     * @private
     */
    name: "app.PlaylistPage.PrefixLayout",

    /**
     * @private
     */
    kind: Layout,

    /**
     * @public
     */
    reflow: function() {
        var $container       = this.container,
            scrollerWidth    = get($container, "scrollerDimensions.scrollerWidth", 0),
            scrollerHeight   = get($container, "scrollerDimensions.scrollerHeight", 0),
            numPlaylistItems = get($container, "state.data.category_content.length", 0),
            numDashboards    = get($container, "state.data.dashboard.length", 0);

        if (!$container.hasNode()) {
            return;
        }

        $container.addStyles({
            width:     scrollerWidth + "px",
            minHeight: numPlaylistItems === 0 && numDashboards === 0 ? scrollerHeight + "px" : null
        });

        this.reflowHeader();
        this.reflowContent();
    },

    /**
     * @public
     */
    reflowHeader: function() {
        var $container = this.container,
            graphicHeight,
            graphicOverflow,
            contentHeight;

        graphicHeight   = get($container, "headerGraphicLayoutMetrics.graphicHeight", 0);
        graphicOverflow = get($container, "headerGraphicLayoutMetrics.graphicOverflow", 0);
        contentHeight   = get($container, "headerContentLayoutMetrics.contentHeight", 0);

        $container.$.header.addStyles({
            height: Math.max(0, graphicHeight - graphicOverflow, contentHeight) + "px"
        });
    },

    /**
     * @public
     */
    reflowContent: function() {
        switch (themeVars.formFactor) {
            case "medium":
            case "large":
                this.reflowContentDesktop();
                break;
            case "tiny":
            case "smaller":
            case "small":
            default:
                this.reflowContentMobile();
                break;
        }
    },

    /**
     * @private
     */
    reflowContentMobile: function() {
        var $container    = this.container,
            $content      = $container.$.content,
            $playlist     = $container.$.playlist,
            $aside        = $container.$.aside,
            scrollerWidth = get($container, "scrollerDimensions.scrollerWidth", 0);

        // No page margins, single-col
        $content.addStyles({
            paddingLeft:  0 + "px",
            paddingRight: 0 + "px"
        });
        $playlist.addStyles({
            width:       scrollerWidth + "px",
            marginRight: 0 + "px"
        });
        $aside.addStyles({
            width: scrollerWidth + "px"
        });
    },

    /**
     * @private
     */
    reflowContentDesktop: function() {
        var $container    = this.container,
            $content      = $container.$.content,
            $playlist     = $container.$.playlist,
            $aside        = $container.$.aside,
            scrollerWidth = get($container, "scrollerDimensions.scrollerWidth", 0),
            pageMarginLeft,
            pageMarginRight,
            columnGap,
            availableWidth,
            leftColumnWidth,
            rightColumnWidth;

        if (themeVars.formFactor === "large") {
            pageMarginLeft  = Math.max(themeVars.safeAreaInsetLeft, themeVars.getPageMarginLargePx());
            pageMarginRight = Math.max(themeVars.safeAreaInsetRight, themeVars.getPageMarginLargePx());
        }
        else {
            pageMarginLeft  = themeVars.safeAreaInsetLeft + themeVars.getPageMarginPx();
            pageMarginRight = themeVars.safeAreaInsetRight + themeVars.getPageMarginPx();
        }

        $content.addStyles({
            width:        "100%",
            paddingLeft:  pageMarginLeft + "px",
            paddingRight: pageMarginRight + "px"
        });

        availableWidth   = scrollerWidth - pageMarginLeft - pageMarginRight;
        columnGap        = themeVars.getContentPaddingHorizontalPx() * 1.5;
        leftColumnWidth  = Math.min(1280, availableWidth);
        rightColumnWidth = 0;

        if (availableWidth <= 1280 + columnGap) {
            $playlist.addStyles({
                width:       leftColumnWidth + "px",
                marginRight: 0 + "px"
            });
            $aside.addStyles({
                width: 0 + "px"
            });
        }
        else {
            rightColumnWidth = availableWidth - leftColumnWidth - columnGap;
            $playlist.addStyles({
                width:       leftColumnWidth + "px",
                marginRight: columnGap + "px"
            });
            $aside.addStyles({
                width: rightColumnWidth + "px"
            });
        }
    }
});
